import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { PinnacleMessage } from "./components";
import { Admin, Donate, Home, NewTeam, NotFound, ViewLeaderboard, ViewLeaderboardTV } from "./pages"; // prettier-ignore

function App() {
  return (
    <div className="App">
      <main className="bx--content">
        <PinnacleMessage />
        <Router>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/donation" element={<Donate />} />
            <Route path="/create_new_team" element={<NewTeam />} />
            <Route path="/view_leaderboard" element={<ViewLeaderboard />} />
            <Route path="/tv" element={<ViewLeaderboardTV />} />
            <Route path="/" exact element={<Home />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </main>
    </div>
  );
}

export default App;
